import { Input, notification } from 'antd';
import React from 'react';
import {
  firstCharIsNotSpecialChar,
  checkIfHasAllowedCharacters
} from '../../../util/stringUtils';

const DEFAULT_STATE = {
  isEditing: false,
  editingGroupName: '',
  error: null
};

class EditableGroupName extends React.Component {
  state = {
    ...DEFAULT_STATE
  };

  checkGroupNameExists = (groupName) => {
    const { groups } = this.props;
    const existingGroupsWithSameName = groups.filter(
      (group) =>
        String(group.groupName).toUpperCase() ===
        String(groupName).toUpperCase()
    );

    return existingGroupsWithSameName.length > 0;
  };

  onEditClick = () => {
    const { groupName } = this.props;
    this.setState({
      isEditing: true,
      editingGroupName: groupName
    });
  };

  onEditCancel = () => {
    this.setState({
      isEditing: false,
      editingGroupName: ''
    });
  };

  onEditingGroupName = (e) => {
    const editingGroupName = e.target.value;
    this.setState({
      editingGroupName
    });
  };

  onConfirmGroupNameChange = () => {
    const { editingGroupName } = this.state;
    const { onConfirmGroupNameChange } = this.props;
    if (
      editingGroupName &&
      editingGroupName.length >= 3 &&
      editingGroupName.length <= 50
    ) {
      if (checkIfHasAllowedCharacters(editingGroupName)) {
        if (firstCharIsNotSpecialChar(editingGroupName)) {
          if (!this.checkGroupNameExists(editingGroupName)) {
            onConfirmGroupNameChange(editingGroupName);

            this.setState({
              ...DEFAULT_STATE
            });
          } else {
            notification.open({
              message: (
                <p>
                  <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
                  &nbsp;&nbsp;Something went wrong
                </p>
              ),
              description: 'Group name already exists.'
            });
          }
        } else {
          notification.open({
            message: (
              <p>
                <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
                &nbsp;&nbsp;Something went wrong
              </p>
            ),
            description:
              'Column name should not start with a special character.'
          });
        }
      } else {
        notification.open({
          message: (
            <p>
              <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
              &nbsp;&nbsp;Something went wrong
            </p>
          ),
          description:
            'Following special characters are allowed :./-&$#@%_(){}\\'
        });
      }
    } else {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
            &nbsp;&nbsp;Something went wrong
          </p>
        ),
        description: 'Column name should have 3-50 characters.'
      });
    }
  };

  renderGroupName = () => {
    const { groupName } = this.props;
    const { isEditing, editingGroupName } = this.state;

    if (isEditing) {
      return (
        <div>
          <Input
            style={{ maxWidth: '200px' }}
            value={editingGroupName}
            onChange={this.onEditingGroupName}
          />
          &nbsp;&nbsp;&nbsp;
          <i
            onClick={this.onConfirmGroupNameChange}
            className="fa fa-check"
            style={{ color: 'rgb(12, 142, 215)', cursor: 'pointer' }}></i>
          &nbsp;&nbsp;&nbsp;
          <span
            onClick={this.onEditCancel}
            style={{ color: 'rgb(223, 96, 87)', cursor: 'pointer' }}>
            x
          </span>
        </div>
      );
    }

    return (
      <p>
        Column name: {groupName}
        &nbsp;&nbsp;&nbsp;
        <i
          onClick={this.onEditClick}
          style={{ color: '#748AA1', cursor: 'pointer' }}
          className="fa fa-edit"></i>
      </p>
    );
  };

  render() {
    return this.renderGroupName();
  }
}

export default EditableGroupName;
